import template from './enter-virtual-data-form.html';
import controller from './enter-virtual-data-form-controller';

const EnterVirtualDataFormComponent = {
    bindings: {
        changeReasonList: '<',
        facilityFields: '<',
        facilitySettings: '<',
        formMetadata: '<',
        isEditMode: '<',
        isFormSaved: '<',
        isFormCommitted: '<',
        lastUpdatedByEmail: '<',
        relatedModels: '<',
        savedFormData: '<',
        showSavedWarning: '<',
        statToLabelDict: '<'
    },
    controller,
    template
};

export default EnterVirtualDataFormComponent;



// WEBPACK FOOTER //
// ./app/components/enter-virtual-data/enter-virtual-data-form/enter-virtual-data-form-component.js